<div [class.dark-theme]="true" class="fix-action-dialog">
	<h1 mat-dialog-title style="padding:16px; color: #ffffff;">{{content.title}}</h1>

	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<div>{{content.message}}</div>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around">
		<button (click)="onAccept()" color="primary" mat-raised-button id="mat-info-button">{{content.ok_button}}</button>
	</mat-dialog-actions>
</div>
